import { Injectable } from '@angular/core';
import { XsI18nPipe } from '@nx-fe/pipes';

@Injectable()
export class UserBadgeService {

    constructor(private saI18nPipe: XsI18nPipe) {
    }

    public getInitials(name: string) {
        if(!name) {
            name = this.saI18nPipe.transform('userBadge_Initials_Default');
        }

        name = name.replace(/[\[\]!@#$%^&*(),.?':{}|<>]/g, '');
        const parts = name.split(' ');

        const firstPart = parts[0].charAt(0);

        // Names with multiple parts will use the first character of the last name.
        // Single part names will use the last character of the name.
        const lastPart = parts.length === 1 ? parts[0].charAt(parts[0].length - 1) : parts[parts.length - 1].charAt(0);

        return this.saI18nPipe.transform('initialsFormat_Caption', firstPart.toLocaleUpperCase(), lastPart.toLocaleUpperCase());
    }

    public getColorIndex(initials: string): number  {
        initials = initials.toUpperCase();
        const firstValue = initials.charCodeAt(0) - 'A'.charCodeAt(0);
        const secondValue = initials.charCodeAt(initials.length - 1) - 'A'.charCodeAt(0);
        return Math.abs((firstValue + secondValue)) % 6 + 1;
    }

    public getXsightColorClass(initials: string): string  {
        const index = this.getColorIndex(initials);
        return `badge-color-${index}`;
    }

    public getXsightColor(initials: string): string  {
        const index = this.getColorIndex(initials);
        switch (index) {
            case 1:
                return '#E74C3C';
            case 2:
                return '#8D44AC';
            case 3:
                return '#1ABC9C';
            case 4:
                return '#27AE61';
            case 5:
                return '#3398DB';
            case 6:
                return '#F39C12';
            default:
                return '#E74C3C';
        }
    }
}
